/**
 * JWT claim shapes, shared so the API signs exactly what the web app expects.
 *
 * The tenant id lives in the access token and is the sole source of tenant scope on
 * the server. It is never read from a header, a query parameter or a request body —
 * that is what makes cross-tenant access a signing problem rather than a validation
 * problem.
 */
export const SUPPORTED_LOCALES = ['fr', 'en', 'ar'];
export const DEFAULT_LOCALE = 'fr';
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
/** Narrows an Accept-Language header or stored preference onto a supported locale. */
export function resolveLocale(candidate) {
    if (!candidate)
        return DEFAULT_LOCALE;
    const primary = candidate.split(',')[0]?.split('-')[0]?.toLowerCase() ?? '';
    return isSupportedLocale(primary) ? primary : DEFAULT_LOCALE;
}
//# sourceMappingURL=tokens.js.map